export default __webpack_public_path__ + "static/media/AXA-color.cf98f81a.svg";